import React from 'react';
import PropTypes from 'prop-types';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';

import {
  IMPORTANCE,
  getColorForImportance,
  getColorHexForImportance,
} from '../../../utils/enumHelper';
import theme from '../../../utils/theme';

class ImportanceSelectComponent extends React.Component {
  render() {
    const {
      onChange,
      value,
      includeAllOption,
      ...rest
    } = this.props;
    // Alert, Moderate, Low, Inform

    return (
      <FormControl fullWidth margin="none" color={getColorForImportance(value)}>
        <InputLabel id="importance-select-label">Importance</InputLabel>
        <Select
          sx={{ '& .MuiInputBase-input': { borderLeft: `8px solid ${getColorHexForImportance(value, theme)}` } }}
          labelId="importance-select-label"
          id="importance-select"
          value={value}
          size="small"
          label="Importance"
          onChange={onChange}
          {...rest}
        >
          {includeAllOption && <MenuItem value="">All</MenuItem>}
          {IMPORTANCE.map((i) => (
            <MenuItem key={`importance-menu-item-${i}`} value={i} sx={{ borderLeft: `8px solid ${getColorHexForImportance(i, theme)}` }}>{i}</MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
}

ImportanceSelectComponent.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  includeAllOption: PropTypes.bool,
};

ImportanceSelectComponent.defaultProps = {
  onChange: () => { },
  value: null,
  includeAllOption: false,
};

export default (ImportanceSelectComponent);
